import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map, tap } from 'rxjs/operators';
import { ApplicationsAdapter } from '../../adapters/applications.adapter';
import { loadApplications, loadApplicationsFailure, loadApplicationsSuccess } from './applications.actions';

@Injectable()
export class ApplicationsEffects {
  private readonly actions$ = inject(Actions);
  private readonly applicationsAdapter = inject(ApplicationsAdapter);

  loadApplications$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadApplications),
      exhaustMap(() =>
        this.applicationsAdapter.getApplications(0).pipe(
          map((result) => loadApplicationsSuccess({ applications: result.applications })),
          catchError((error) => {
            return of(loadApplicationsFailure({ error }));
          })
        )
      )
    )
  );
  loadApplicationsFailure$;

  constructor() {
    this.loadApplications$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadApplications),
        exhaustMap(() =>
          this.applicationsAdapter.getApplications(0).pipe(
            map((result) =>
              loadApplicationsSuccess({ applications: result.applications })
            ),
            catchError((error) => {
              return of(loadApplicationsFailure({ error }));
            })
          )
        )
      )
    );

    this.loadApplicationsFailure$ = createEffect(
      () =>
        this.actions$.pipe(
          ofType(loadApplicationsFailure),
          tap((action) => {
            // Todo: Add proper error handling. Maybe with a toasty?
            //alert(action.error.message);
          })
        ),
      { dispatch: false }
    );
  }
}
